import { Typography } from '@mui/material'

export default function Footer() {
  return (
    <div style={{ textAlign: 'center', width: '80%', margin: 'auto' }}>
      <Typography style={{ fontFamily: 'GenYOGothic2TW', color: '#353535' }}>
        行創版權所有 Copyright © 2025 ACTIVE INNOVATION All Rights Reserved.
      </Typography>
    </div>
  )
}
